import React, { useContext } from 'react';
import AuthContext from 'context/AuthContext';
import MapBase from 'components/maps/MapBase';
import AzureMapBase from 'components/maps/azure/AzureMapBase';
import AzureMapMarker from 'components/maps/azure/AzureMapMarker';

/**
 * MapBaseManager - Dynamic switcher for base maps.
 */
const MapBaseManager = (props) => {
    const { panel } = useContext(AuthContext);
    const provider = props.provider || panel?.map_type || panel?.map_provider || 'lf';

    switch (provider) {
        case 'az':
            return (
                <AzureMapBase {...props}>
                    {props.position && !props.children && (
                        <AzureMapMarker position={props.position} />
                    )}
                    {props.children}
                </AzureMapBase>
            );
        case 'lf':
        default:
            return <MapBase {...props} />;
    }
};

export default MapBaseManager;
